module.exports = __webpack_public_path__ + "static/media/protest.03917917.jpg";